import React from 'react';
import { DndProvider } from 'react-dnd-multi-backend';
import HTML5toTouch from 'react-dnd-multi-backend/dist/esm/HTML5toTouch';

import { Container, Row, Col } from 'react-bootstrap';
import DndList from '../../Components/DndList';

const RankingQuestion = ({ options, setOptions, title }) => {
    return (
        <Container>
            <Row>
                <Col className="h6">{title}</Col>
            </Row>
            <Row>
                <Col>
                    <DndProvider options={HTML5toTouch}>
                        <DndList cards={options} setCards={setOptions} />
                    </DndProvider>
                </Col>
            </Row>
        </Container>
    );
};

export default RankingQuestion;
